import { Box, Dialog } from '@mui/material'
import { useAttachmentImageGallery } from './useAttachmentImageGallery'
import { AttachmentImageGalleryHeader } from './AttachmentImageGalleryHeaderBody.jsx'
import { AttachmentImageGalleryStage } from './AttachmentImageGalleryStage'
import { AttachmentImageGalleryFooter } from './AttachmentImageGalleryFooter'
import { attachmentGalleryDialogSlotProps } from './attachmentGalleryDialogSlotProps.js'
import styles from '../AttachmentImageGallery.module.scss'

export default function AttachmentImageGalleryView(props) {
  const { open, onClose, items, initialIndex = 0, senderLabel = 'You', subtitle, secondaryLine } = props
  const gallery = useAttachmentImageGallery({ open, items, initialIndex, subtitle })
  if (gallery.safeLen === 0) return null

  return (
    <Dialog fullScreen open={open} onClose={onClose} className={styles.dialogRoot} slotProps={attachmentGalleryDialogSlotProps} aria-labelledby="attachment-image-gallery-title">
      <Box className={styles.shell} onClickCapture={(e) => gallery.handleScrimClickCapture(e, onClose)}>
        <AttachmentImageGalleryHeader
          senderLabel={senderLabel}
          resolvedSubtitle={gallery.resolvedSubtitle}
          secondaryLine={secondaryLine}
          zoom={gallery.zoom}
          onClose={onClose}
          zoomOut={gallery.zoomOut}
          zoomIn={gallery.zoomIn}
          onDownload={gallery.handleDownload}
          current={gallery.current}
        />
        <AttachmentImageGalleryStage
          canPrev={gallery.canPrev}
          canNext={gallery.canNext}
          goPrev={gallery.goPrev}
          goNext={gallery.goNext}
          previewSrc={gallery.previewSrc}
          current={gallery.current}
          zoom={gallery.zoom}
        />
        <AttachmentImageGalleryFooter
          items={items}
          activeIndex={gallery.activeIndex}
          setActiveIndex={gallery.setActiveIndex}
          setZoom={gallery.setZoom}
          thumbRefs={gallery.thumbRefs}
          safeLen={gallery.safeLen}
        />
      </Box>
    </Dialog>
  )
}
